import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API_URL } from '../context/AuthContext';

export default function Navbar({ tema, titulo, tipo, nivel }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const [esMobile, setEsMobile] = useState(() => window.innerWidth <= 600);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const [passActual, setPassActual] = useState('');
  const [passNueva, setPassNueva] = useState('');
  const [passConfirm, setPassConfirm] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [mensajeOk, setMensajeOk] = useState('');
  const [errorPass, setErrorPass] = useState('');
  const menuRef = useRef(null);

  useEffect(() => {
    const check = () => setEsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // Cierra el dropdown al hacer clic fuera
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuAbierto(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleLogout = () => { logout(); navigate('/'); };

  const abrirModalPassword = () => {
    setMenuAbierto(false);
    setPassActual(''); setPassNueva(''); setPassConfirm('');
    setErrorPass(''); setMensajeOk('');
    setModalPassword(true);
  };

  const handleCambiarPassword = async (e) => {
    e.preventDefault();
    setErrorPass(''); setMensajeOk('');
    if (passNueva !== passConfirm) return setErrorPass('Las contraseñas nuevas no coinciden');
    if (passNueva.length < 6) return setErrorPass('La contraseña debe tener al menos 6 caracteres');
    setGuardando(true);
    try {
      await axios.put(`${API_URL}/auth/cambiar-password`, {
        password_actual: passActual,
        password_nuevo: passNueva,
      });
      setMensajeOk('¡Contraseña actualizada correctamente!');
      setPassActual(''); setPassNueva(''); setPassConfirm('');
    } catch (e) {
      setErrorPass(e.response?.data?.error || 'Error al cambiar la contraseña');
    } finally { setGuardando(false); }
  };

  const accent = tema?.accent || '#EC4899';
  const inputStyle = {
    width: '100%', padding: '10px 14px', borderRadius: '8px',
    background: tema?.bg || '#FFF0F5',
    border: `1px solid ${tema?.border || '#FBCFE8'}`,
    color: tema?.text || '#581C47', fontSize: '14px', boxSizing: 'border-box',
  };

  return (
    <>
      <nav style={{
        background: tema?.bgCard || '#FFFFFF',
        borderBottom: `1px solid ${tema?.border || '#FBCFE8'}`,
        padding: '0 14px',
        height: '60px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        position: 'sticky', top: 0, zIndex: 100,
        boxShadow: '0 2px 16px rgba(236,72,153,0.08)',
        gap: '8px',
      }}>
        {/* Izquierda: título + nivel */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, overflow: 'hidden' }}>
          {titulo && (
            <span style={{
              color: tema?.text || '#581C47', fontWeight: 700,
              fontSize: esMobile ? '13px' : '15px',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>
              {titulo}
            </span>
          )}
          {nivel && (
            <span style={{
              background: `${accent}18`,
              color: accent,
              border: `1px solid ${accent}44`,
              borderRadius: '6px', padding: '3px 8px',
              fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0,
            }}>
              {nivel}
            </span>
          )}
        </div>

        {/* Derecha: avatar + dropdown + botón cerrar sesión */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          {/* Avatar + nombre — abre dropdown */}
          <div ref={menuRef} style={{ position: 'relative' }}>
            <button
              onClick={() => setMenuAbierto(v => !v)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                background: 'none', border: 'none', cursor: 'pointer', padding: '4px 6px',
                borderRadius: '8px',
                outline: 'none',
              }}
            >
              <div style={{
                width: 32, height: 32, borderRadius: '50%',
                background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '13px', fontWeight: 700, color: '#fff',
                boxShadow: '0 2px 8px rgba(236,72,153,0.3)', flexShrink: 0,
              }}>
                {usuario?.nombre?.charAt(0).toUpperCase()}
              </div>
              {!esMobile && (
                <div style={{ lineHeight: 1.3, textAlign: 'left' }}>
                  <div style={{ color: tema?.text || '#581C47', fontSize: '13px', fontWeight: 600 }}>
                    {usuario?.nombre}
                  </div>
                  <div style={{ color: accent, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700 }}>
                    {usuario?.rol}
                  </div>
                </div>
              )}
              <span style={{ color: tema?.muted || '#BE84A3', fontSize: '10px' }}>▾</span>
            </button>

            {/* Dropdown */}
            {menuAbierto && (
              <div style={{
                position: 'absolute', top: 'calc(100% + 6px)', right: 0,
                background: tema?.bgCard || '#FFFFFF',
                border: `1px solid ${tema?.border || '#FBCFE8'}`,
                borderRadius: '10px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                minWidth: '180px', zIndex: 200, overflow: 'hidden',
              }}>
                {esMobile && (
                  <div style={{ padding: '12px 16px', borderBottom: `1px solid ${tema?.border || '#FBCFE8'}` }}>
                    <div style={{ color: tema?.text || '#581C47', fontSize: '13px', fontWeight: 600 }}>{usuario?.nombre}</div>
                    <div style={{ color: accent, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700 }}>{usuario?.rol}</div>
                  </div>
                )}
                <button
                  onClick={abrirModalPassword}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
                    background: 'none', border: 'none', padding: '12px 16px',
                    color: tema?.text || '#581C47', fontSize: '14px', cursor: 'pointer',
                    textAlign: 'left',
                  }}
                >
                  🔑 Cambiar contraseña
                </button>
                <div style={{ height: '1px', background: tema?.border || '#FBCFE8' }} />
                <button
                  onClick={handleLogout}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
                    background: 'none', border: 'none', padding: '12px 16px',
                    color: '#e74c3c', fontSize: '14px', cursor: 'pointer',
                    textAlign: 'left',
                  }}
                >
                  ✕ Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Modal cambiar contraseña */}
      {modalPassword && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px',
        }}>
          <div style={{
            background: tema?.bgCard || '#FFFFFF',
            border: `1px solid ${tema?.border || '#FBCFE8'}`,
            borderRadius: '16px', padding: '28px',
            width: '100%', maxWidth: '420px',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ color: tema?.text || '#581C47', fontSize: '18px', margin: 0 }}>🔑 Cambiar contraseña</h3>
              <button onClick={() => setModalPassword(false)}
                style={{ background: 'none', border: 'none', color: tema?.muted || '#BE84A3', cursor: 'pointer', fontSize: '20px', lineHeight: 1 }}>
                ×
              </button>
            </div>

            {mensajeOk && (
              <div style={{ background: '#22C55E10', border: '1px solid #22C55E44', borderRadius: '8px', padding: '12px', color: '#22C55E', fontSize: '14px', marginBottom: '16px' }}>
                {mensajeOk}
              </div>
            )}
            {errorPass && (
              <div style={{ background: 'rgba(231,76,60,0.1)', border: '1px solid rgba(231,76,60,0.3)', borderRadius: '8px', padding: '12px', color: '#e74c3c', fontSize: '14px', marginBottom: '16px' }}>
                {errorPass}
              </div>
            )}

            <form onSubmit={handleCambiarPassword}>
              <div style={{ marginBottom: '14px' }}>
                <label style={{ color: tema?.muted || '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '6px' }}>
                  Contraseña actual *
                </label>
                <input
                  type="password" style={inputStyle} value={passActual}
                  onChange={e => setPassActual(e.target.value)} required autoComplete="current-password"
                />
              </div>
              <div style={{ marginBottom: '14px' }}>
                <label style={{ color: tema?.muted || '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '6px' }}>
                  Nueva contraseña *
                </label>
                <input
                  type="password" style={inputStyle} value={passNueva}
                  onChange={e => setPassNueva(e.target.value)} required autoComplete="new-password"
                  placeholder="Mínimo 6 caracteres"
                />
              </div>
              <div style={{ marginBottom: '24px' }}>
                <label style={{ color: tema?.muted || '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '6px' }}>
                  Confirmar nueva contraseña *
                </label>
                <input
                  type="password" style={inputStyle} value={passConfirm}
                  onChange={e => setPassConfirm(e.target.value)} required autoComplete="new-password"
                />
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" disabled={guardando}
                  style={{
                    flex: 1, background: `linear-gradient(135deg, ${accent} 0%, ${accent}cc 100%)`,
                    border: 'none', color: '#fff', padding: '11px', borderRadius: '50px',
                    fontSize: '14px', fontWeight: 600, cursor: 'pointer',
                    boxShadow: `0 4px 14px ${accent}44`,
                  }}>
                  {guardando ? 'Guardando...' : 'Cambiar contraseña'}
                </button>
                <button type="button" onClick={() => setModalPassword(false)}
                  style={{
                    background: 'none', border: `1px solid ${tema?.border || '#FBCFE8'}`,
                    color: tema?.muted || '#BE84A3', padding: '11px 18px',
                    borderRadius: '8px', fontSize: '14px', cursor: 'pointer',
                  }}>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
